import { Column, defaultColActionDef, defaultColDef, TABLE_ACTION } from '@qrios/frontend-library';

import { predefinedColumns } from '../../../../../common/table/columns/predefinedColumns';

const ACTIONS = [TABLE_ACTION.INFO];

export const columns: Column[] = [
  {
    ...defaultColDef,
    field: 'id',
    headerName: 'Operation id',
    flex: 2
  },
  predefinedColumns.date({}),
  predefinedColumns.status({}),
  {
    ...defaultColDef,
    field: 'customerMsisdn',
    headerName: 'Customer phone number',
    flex: 2
  },
  {
    ...defaultColDef,
    field: 'providerName',
    headerName: 'Provider name',
    flex: 1
  },
  {
    ...defaultColDef,
    field: 'authenticationMethod',
    headerName: 'Method',
    flex: 1
  },
  predefinedColumns.cost({}),
  {
    ...defaultColActionDef(ACTIONS)
  }
];
